<router-outlet></router-outlet>
<ng-container *ngIf="project$ | async">
    <nt-feedback-button></nt-feedback-button>
</ng-container>
<ng-container *ngIf="error$ | async"></ng-container>
